import { Component, NgModule, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GridApi, ColumnApi, GridOptions, ColDef, RowClickedEvent, PaginationChangedEvent, GridReadyEvent, Column, FilterChangedEvent, FilterModifiedEvent, FilterOpenedEvent } from 'ag-grid-community';import Swal from 'sweetalert2'
import { IMerchantData } from '../service-provider-management.component';
import { BtnCellRenderer } from 'src/app/common/button-cell-renderer.component';
import { environment } from 'src/environments/environment';
import { MerchantService } from '../../merchants/merchant-master/merchant.service';
import { Location } from '@angular/common';
import { ServiceProviderService } from '../service-provider-service';
import { Observable, retry } from 'rxjs';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import * as moment from 'moment';
import { AlertService } from 'src/app/_services/alert.service';
import { AmountInputCellRenderer } from 'src/app/common/amount-input-cell-renderer.component';
import { DatepickerCellRenderer } from 'src/app/common/datepicker-cell-renderer.component';
import { InputCellRenderer } from 'src/app/common/input-cell-renderer.component';
import { SelectCellRenderer } from 'src/app/common/select-cell-renderer.component';
import { ProductService } from '../../product-management/product-service';
import { ProductSubCategoryService } from '../../product-subcategory-management/product-subcategory-service';
import { MenusService } from 'src/app/_services/menu.service';
import { ModalComponent } from 'src/app/common/modal/modal.component';
import { ModalConfig } from 'src/app/common/modal/modal.config';
import { NgSelectModule } from '@ng-select/ng-select';


export interface CustomerListFilter {
  "columns"?: any;
  "fullname"?: string,
  "mobile"?: string,
  "startDate"?: string,
  "endDate"?: string,
  "pageRecords"?: number,
  "pageNumber"?: number,
  "emailId"?: string,
  "Status"?: string,
  "KycStatus"?: string

}

export class ProductTable{
  "id": number
  "productIcon":any
  "productName" : string
  "categoryName" : string
  "subCategoryName": string
  
}

export class SlabTableFormat {
  "id": number;
  "fromAmount": number;
  "toAmount": number;
  "commissionType": String;
  "commission": number;
  "minCommission": number;
  "maxCommission": number;
  "effectiveUpdatedDate": String;
  "productId" : number;
  "updatedBy": String;
  "updatedOn": String;
  "approvedBy": String;
  "aprrovedOn": String;
  "isAmountDisabled": Boolean;
  "showEditButton": Boolean;
  "isDatepickerDisabled": Boolean;
  "isSelectDisabled": Boolean;
}

const { API_URL, defaultPageSizeArr, defaultPageSize,defaultPhoneCode } = environment;

@Component({
  selector: 'app-service-provider-edit',
  templateUrl: './service-provider-edit.component.html',
  styleUrls: ['./service-provider-edit.component.scss']
  
})
 

export class ServiceProviderEditComponent implements OnInit {

  @ViewChild('openReviewSlab') private editServiceProviderModal: ModalComponent;
  modalServiceProviderReview: ModalConfig;
  @ViewChild('statusChange') private statusChangeModal: ModalComponent;
  modalStatusChange: ModalConfig;
  isDisabled: boolean;
  public permissions: any = '';
  editServiceProviderForm: FormGroup;
  submitted: boolean = false;
  editCommissionForm: FormGroup;
  submittedCommission: boolean = false;
  activeTab: any = "service";
  globalSearch: string = '';
  public rowData!: IMerchantData[];
  private filterObj: any = {};
  private gridApi!: GridApi;
  collectiondata: number = 0;
  collectionSize: number = 0;
  private gridColumnApi!: ColumnApi;
  currentPage: number = 1;
  public pageNumber: number
  ellipses: boolean = true;
  maxSize: number;
  productTableClass : ProductTable;
  productTableList :any [];
  productIds : any [];
  dummyProductIds : any [];
  editProductForm: FormGroup;
  dbStatus : string;
  selectedStatus : string;
  productNumber : number;
  countryId: any;
  countryName:any;
  private columnApi: ColumnApi;
  private gridApiSavedData: GridApi;
  private gridApiSlab: GridApi;
  slabTypeData: SlabTableFormat;
  public directData: any[];
  public slabData: any[];
  slabRemarks : string;
  public finalCommissionData : any[];
  showDataTable : boolean = false;
  showSavedTable : boolean = false;
  showSlabMessage : boolean = false;
  countryDropDown : any[];
  categoryDropDown : any[];
  subCategoryDropDown : any[];
  productDropDown : any[];
  selectedProductVisible : boolean = false;
  selectedProduct : any;

  id : any;
  pid : any[];
  savedSlabData : any[];
  showAddSlabButton : boolean= false;
  contact : [];

  showOldSlab : boolean = false;
  showNewSlab : boolean = false;
  oldSlab : any[];
  newSlab : any[];
  formDisabled : boolean = false;
  


  public defaultColDef: ColDef = {
    flex: 1,
    minWidth: 160,
    resizable: true,
    sortable: true,
    filter: false,
    autoHeight: true
  };

  public reviewSlabCol: ColDef = {
    flex: 1,
    minWidth: 120,
    resizable: true,
    sortable: true,
    filter: false,
    autoHeight: true
  };

  public columnDefSavedData: ColDef[] = [
    {field: 'commissionType', headerName: 'Commission Type',editable:false,lockVisible:true},
    {field: 'commission', headerName: 'Commission', editable:false,lockVisible:true},
    {field: 'minCommission', headerName: 'Minimum Commission',editable:false,lockVisible:true},
    {field: 'maxCommission', headerName: 'Maximum Commission',editable:false,lockVisible:true},
    {field: 'fromAmount', headerName: 'From Amount', editable:false,lockVisible:true},
    {field: 'toAmount', headerName: 'To Amount',editable:false,lockVisible:true},
    {field: 'id', headerName: 'ID', hide: true },
    {field: 'effectiveUpdatedDate', headerName: 'Effective Update Date',editable:false,lockVisible:true},
    {field: 'createdOn', headerName: 'Created On',editable:false,lockVisible:true},
    {field: 'createdBy', headerName: 'Created By',editable:false,lockVisible:true},
    {field: 'approvedOn', headerName: 'Approved On',editable:false,lockVisible:true},
    {field: 'approvedBy', headerName: 'Approved By',editable:false,lockVisible:true},
    {field: 'status', headerName: 'Status',editable:false,lockVisible:true},
  ];

  public columnDefs: ColDef[] = [
    {
      field: 'commissionType', headerName: 'Commission Type', cellRenderer: SelectCellRenderer, cellEditorParams: {
        options: [
          { value: 'FLAT', label: 'FLAT' },
          { value: 'PERCENTAGE', label: 'PERCENTAGE' },
        ]
      }
    },
    { field: 'commission', headerName: 'Commission', cellRenderer: InputCellRenderer },
    { field: 'minCommission', headerName: 'Minimum Commission', cellRenderer: InputCellRenderer },
    { field: 'maxCommission', headerName: 'Maximum Commission', cellRenderer: InputCellRenderer },
    {field: 'fromAmount', headerName: 'From Amount', editable:false, cellRenderer: AmountInputCellRenderer,},
    {
      field: 'toAmount', headerName: 'To Amount', resizable: true, cellRenderer: AmountInputCellRenderer, onCellValueChanged: (params: any) => {
        const toAmountValue = parseFloat(params.newValue);
        const maxBalanceValue = parseFloat(this.editServiceProviderForm.value.maxBalance);
        if (!isNaN(toAmountValue) && toAmountValue < maxBalanceValue) {
          const nextRowVal = this.gridApiSlab.getDisplayedRowAtIndex(params.node.rowIndex + 1)!.data;
          const rowNode = this.gridApiSlab.getRowNode((params.node.rowIndex + 1).toString());
          if (rowNode) {
            const nextFromAmount = parseFloat((toAmountValue + 0.01).toFixed(2));
            this.finalCommissionData[params.node.rowIndex + 1].fromAmount = nextFromAmount;
            const newData = { ...rowNode.data, fromAmount: nextFromAmount };
            rowNode.setData(newData);
            this.gridApiSlab.refreshCells({ rowNodes: [rowNode], force: true });
          }
        }
      }
    },
    { field: 'id', headerName: 'ID', hide: true },
    {
      field: 'effectiveUpdatedDate', headerName: 'Effective Update Date', cellRenderer: DatepickerCellRenderer, onCellValueChanged: (params: any) => {
        this.finalCommissionData.map((_: any, i: number) => {
          _.effectiveUpdatedDate = moment(params.newValue, ['YYYY-MM-DD HH:mm']).format("MM-DD-YYYY HH:mm");
        })
        this.gridApiSlab.setRowData(this.finalCommissionData);
      }
    },

  ];

  columnDefsCopy: ColDef[] = [...(this.columnDefs.filter((col) => !col?.hide))];
  tableSelectedColumn: ColDef[] = [...(this.columnDefs.filter((col) => !col?.hide))];
  savedDataColumn: ColDef[] = [...(this.columnDefSavedData.filter((col) => !col?.hide))];

  constructor(private router: Router,private location : Location,private merchantService : MerchantService,private formBuilder : FormBuilder,private alertService : AlertService, private productService : ProductService, private subCategoryService : ProductSubCategoryService,private sanitizer: DomSanitizer,private providerService : ServiceProviderService,private route : ActivatedRoute,private menuService :MenusService) { }

  ngOnDestroy(){
    console.log("Component Service Provider Destoryed");
    if(this.statusChangeModal.isOpen()){
      this.statusChangeModal.close();
    } 

    if(this.editServiceProviderModal.isOpen()){
      this.editServiceProviderModal.close();
    }
  }

  ngOnInit() {

    const path = "/serviceProviderList";
    this.permissions = this.menuService.getPermissions(path);
    console.log(this.permissions);
    // if(this.permissions.includes('View')){
    //   this.formDisabled =true
    // }

    this.activeTab ="service";
    this.productTableList = [];
    this.productIds = [];
    this.directData = [];
    // this.slabData = [];
    
    if(!this.formDisabled){
      this.editServiceProviderForm = this.formBuilder.group({
        serviceProviderName : ['',Validators.required],
        serviceProviderDesc : ['',Validators.required],
        serviceProviderCode : ['',Validators.required],
        country : [null,Validators.required],
        contactCountryCode : [defaultPhoneCode,Validators.required],
        countryName:[{value: ''}],  
        contactNumber : ['',[Validators.required, Validators.pattern('[123456789][0-9]{8}')]],
        emailId : ['',[Validators.required, Validators.email, Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,10}$')]],
        status : [null,Validators.required],
        category : [null],
        subCategory : [null],
        maxBalance : ['',Validators.required],
        product : [null]
      })

      this.editServiceProviderForm.get("contactCountryCode")?.valueChanges.subscribe(
        (data: any) => {
          console.log(data);
          let newPattern = data === defaultPhoneCode ? "[123456789][0-9]{8}" : "[123456789][0-9]{9}"
          const inputFieldControl = this.editServiceProviderForm.get('contactNumber');
          inputFieldControl?.setValidators([Validators.required,Validators.pattern(newPattern)]);
          inputFieldControl?.updateValueAndValidity();
        }
      )
    }else{
      this.editServiceProviderForm = this.formBuilder.group({
        serviceProviderName : [{value: '', disabled: this.formDisabled},Validators.required],
        serviceProviderDesc : [{value: '', disabled: this.formDisabled},Validators.required],
        serviceProviderCode : [{value: '', disabled: this.formDisabled},Validators.required],
        country : [{value: null, disabled: this.formDisabled},Validators.required],
        contactCountryCode : [{value: defaultPhoneCode, disabled: this.formDisabled},Validators.required],
        contactNumber : [{value: '', disabled: this.formDisabled},[Validators.required,Validators.pattern('[123456789][0-9]{8}')]],
        emailId : [{value: '', disabled: this.formDisabled},[Validators.required, Validators.email, Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,10}$')]],
        status : [{value: null, disabled: this.formDisabled},,Validators.required],
        category : [{value: null, disabled: this.formDisabled},],
        subCategory : [{value: null, disabled: this.formDisabled},],
        maxBalance : [{value: '', disabled: this.formDisabled},,Validators.required],
        product : [{value: null, disabled: this.formDisabled},]
      })
      this.editServiceProviderForm.get("contactCountryCode")?.valueChanges.subscribe(
        (data: any) => {
          console.log(data);
          let newPattern = data === defaultPhoneCode ? "[123456789][0-9]{8}" : "[123456789][0-9]{9}"
          const inputFieldControl = this.editServiceProviderForm.get('contactNumber');
          inputFieldControl?.setValidators([Validators.pattern(newPattern)]);
          inputFieldControl?.updateValueAndValidity();
        }
      )

    }
     

    this.editCommissionForm = this.formBuilder.group({
      product: [null, Validators.required],
    })

    this.productService.getCountryDropdown().subscribe((response:any)=>{
      console.log("Countries Loaded");
      console.log(response);
      this.countryDropDown = response.response.data;
      console.log(this.countryId)
      // this.editServiceProviderForm.controls.country.setValue(this.countryId); 
      
    })

    this.subCategoryService.getCategoryDropdown().subscribe((response: any) => {
      this.categoryDropDown = response.response.data;
      this.subCategoryDropDown = [];
      this.productDropDown = [];
    })

    this.id = this.route.snapshot.queryParamMap.get("mid");
    this.providerService.getServiceProviderById(this.id).subscribe((response:any)=>{
      console.log(response);
      this.setGetApiDataById(response);
    })

    this.modalStatusChange = {
      modalTitle: "Service Provider Status",
      modalSize: 'lg',
      hideDismissButton(): boolean {
        return true
      },
      hideCloseButton(): boolean {
        return true
      }
    }

    this.modalServiceProviderReview = {
      modalTitle: "Service Provider Slab",
      modalSize: 'xl',
  
      hideDismissButton(): boolean {
        return true
      },
      hideCloseButton(): boolean {
        return true
      }
    }
  
    if(this.permissions.includes("Approve")){
      this.isDisabled=true;
    }

  }

  
  cancelButton(){
    this.router.navigateByUrl('/serviceProviderList')
  }

  setGetApiDataById(response:any){
    this.productTableList = [];
    this.productIds = [];
    this.editServiceProviderForm.controls.serviceProviderName.setValue(response.response.data.name);
      this.editServiceProviderForm.controls.serviceProviderDesc.setValue(response.response.data.description);
      this.editServiceProviderForm.controls.serviceProviderCode.setValue(response.response.data.code);
      
      console.log(response.response.data.countryName);
      
      this.editServiceProviderForm.controls.countryName.setValue(response.response.data.countryName);
      this.editServiceProviderForm.controls.status.setValue(response.response.data.status);
      let contact = response.response.data.contact;
      this.editServiceProviderForm.controls.contactNumber.setValue(contact.split(" ")[1]);
      this.editServiceProviderForm.controls.contactCountryCode.setValue(contact.split(" ")[0]);
      this.editServiceProviderForm.controls.emailId.setValue(response.response.data.email);
      this.editServiceProviderForm.controls.maxBalance.setValue(response.response.data.maxBalance);
      this.dummyProductIds = response.response.data.productIds;

      for(let i:number=0;i<this.dummyProductIds.length;i++){
        this.productService.getProductById(this.dummyProductIds[i]).subscribe((productData:any)=>{
        console.log(productData);
        let productTableClass = new ProductTable;
        this.setProductProfileByApi(productData.response.data.icon).subscribe((imageData:any)=>{
        console.log(imageData);
        if(imageData.type == 'application/json'){
          productTableClass.productIcon = "assets/images/product.png";
        }else{
          let imageUrl = URL.createObjectURL(imageData);
          productTableClass.productIcon = this.sanitizer.bypassSecurityTrustUrl(imageUrl);
        }
        
        console.log(productTableClass.productIcon);
        productTableClass.productName = productData.response.data.productName;
        productTableClass.id = this.dummyProductIds[i];
        productTableClass.categoryName = productData.response.data.categoryName;
        productTableClass.subCategoryName = productData.response.data.subCategoryName;
        this.productTableList.push(productTableClass);
        this.productIds.push(this.dummyProductIds[i]);
        this.productTableList = [...this.productTableList];
        console.log(this.productTableList);
        console.log(this.productIds);
        });
        })
      }
      console.log("Country ID "+response.response.data.countryId)
      this.editServiceProviderForm.controls.country.setValue(response.response.data.countryId);
      console.log("Country ID Form "+this.editServiceProviderForm.value.country)
  }

  categoryChange(category: any) {
    console.log(category.id);
    this.productService.getSubCategoryDropdownById(category.id).subscribe((response: any) => {
      this.subCategoryDropDown = response.response.data;
    });
    this.editServiceProviderForm.controls.subCategory.setValue(null)
    this.editServiceProviderForm.controls.product.setValue(null)

  }

  subCategoryChange(subCategory : any){
    console.log(subCategory.name);
    this.productService.getProductList("","",subCategory.name,"","",50,0,"","").subscribe((response: any) => {
      this.productDropDown = response.content;
    });
    this.editServiceProviderForm.controls.product.setValue(null)
  }

  saveServiceProvider(data:any){
    this.submitted = true;
    console.log(data);
    if(this.editServiceProviderForm.valid){
      console.log("Valid");
      if (this.productTableList.length == 0) {
        this.alertService.errorAlertWithMessage("Please add the product");
        return;
      }
      console.log(this.productIds);
      console.log(data);
      let requestForm = {
        "id" : this.id,
        "name": this.editServiceProviderForm.value.serviceProviderName,
        "code" : this.editServiceProviderForm.value.serviceProviderCode,
        "contact": this.editServiceProviderForm.value.contactCountryCode+" "+this.editServiceProviderForm.value.contactNumber,
        "email": this.editServiceProviderForm.value.emailId,
        "status" : this.editServiceProviderForm.value.status,
        "countryId" : this.editServiceProviderForm.value.country,
        "description": this.editServiceProviderForm.value.serviceProviderDesc,
        "productIds": this.productIds,
        "maxBalance" : this.editServiceProviderForm.value.maxBalance,
      };
      this.providerService.updateServiceProvider(requestForm).subscribe((response:any)=>{
      console.log(response);
      if(response.response.status == 200){
          this.activeTab = "commission";
          this.providerService.getServiceProviderById(this.id).subscribe((response:any)=>{
            console.log(response);
            this.setGetApiDataById(response);
          })
      }else{
        this.alertService.toastWarringMessageAlertWithMessage("Error while update service provider");
        return;
      }

      
    })

    }else{
      console.log("Not Valid");
    }
  }

  saveCommission(data:any){
    if(this.editCommissionForm.valid){
      console.log("Valid");
      if(this.finalCommissionData.length == 0){
        this.alertService.errorAlertWithMessage("Please set the slab for selected product");
        return;
      }else{
        this.finalCommissionData = JSON.parse(JSON.stringify(this.finalCommissionData));
        this.finalCommissionData.map((_:any)=>{
        delete _.isAmountDisabled;
        delete _.countryId;
        delete _.dateTo;
        delete _.type;
        delete _.updateDate;
        delete _.id;
        delete _.serviceProviderId;
      })
      console.log(data);
      let requestForm = {
        "id" : this.id,
        "slabs" : this.finalCommissionData,
      };
      this.providerService.updateServiceProviderSlab(requestForm).subscribe((response:any)=>{
        console.log(response);
        if(response.response.status == 200){
          Swal.fire(response.response.message, '', 'success').then((result)=>{
            if (result.isConfirmed) {
              this.router.navigate(['/serviceProviderList']);
            } 
          });
        }else if(response.response.status == 400){
          Swal.fire(response.response.message, '', 'error');
          return;
        }else{
          Swal.fire('Error while saving service provider', '', 'error');
        }
      })
      }
    }else{
      console.log("Not Valid");
    }
  }


  switchTab(tab: string): void {
    this.activeTab = tab;
  }

  onGridReady(params: GridReadyEvent<any>) {
    this.gridApiSlab = params.api
  }
  onGridReadySavedData(params: GridReadyEvent<any>){
    this.gridApiSavedData = params.api
  }


  addProduct(){
   console.log("clicked");
    this.submitted = true;
    if(this.editServiceProviderForm.valid){
      console.log("Valid");
    }else{
      console.log("Not valid");
      return;
    }
    if(this.editServiceProviderForm.value.maxBalance == "" || this.editServiceProviderForm.value.maxBalance == null){
      this.alertService.errorAlertWithMessage("Enter Maximum Balance");
      return;
    }

    if(parseInt(this.editServiceProviderForm.value.maxBalance) == 0){
      this.alertService.errorAlertWithMessage("Maximum Balance cannot be 0");
      return;
    }
    
    for(let i:number = 0;i<this.productTableList.length;i++){
      if(this.editServiceProviderForm.value.product.name==this.productTableList[i].productName){
        this.alertService.errorAlertWithMessage("Please select different product it is already mapped");
        return;
      }
    }
    this.productTableClass = new ProductTable;
    //call api for getting product by id for (icon,productName,categoryName,subCategoryName)
    this.productService.getProductById(this.editServiceProviderForm.value.product.id).subscribe((response:any)=>{
      this.setProductProfileByApi(response.response.data.icon).subscribe((response:any)=>{
        console.log(response);
        let imageUrl = URL.createObjectURL(response);
        this.productTableClass.productIcon = this.sanitizer.bypassSecurityTrustUrl(imageUrl);
        console.log(this.productTableClass.productIcon);
    });
    })
    
    this.productTableClass.productName = this.editServiceProviderForm.value.product.name;
    this.productTableClass.id = this.editServiceProviderForm.value.product.id;
    this.productTableClass.categoryName = this.editServiceProviderForm.value.category.name;
    this.productTableClass.subCategoryName = this.editServiceProviderForm.value.subCategory.name;
    this.productTableList.push(this.productTableClass);
    this.productTableList = [...this.productTableList];
    this.productIds.push(JSON.stringify(this.editServiceProviderForm.value.product.id));
    console.log(this.productIds);
    console.log(this.productTableList);
    

 
  }


  get editServiceProviderFormControl() {
    return this.editServiceProviderForm.controls;
  }

  productChange(productSelect : any){
    this.selectedProductVisible = false;
    this.selectedProduct = "";
    this.slabData = [];
    this.finalCommissionData = [];
    this.selectedProduct = productSelect;
    console.log(this.selectedProduct);
    this.showSavedTable = false;
    this.showSlabMessage = false;
    this.showDataTable = false;
    this.savedSlabData = [];
    if(this.editCommissionForm.valid){
      this.selectedProductVisible = true;
      this.providerService.getServiceProviderSlabById(this.id,this.selectedProduct.id).subscribe((response:any)=>{
      console.log(response.response.data.slabs);
      if(response.response.data.slabs.length != 0){
        this.showSavedTable = true;
        this.savedSlabData = response.response.data.slabs;
      }else{
        this.showSavedTable = false;
        this.showSlabMessage = true;
      }
      })
    }
    
  }

  onCellValueChanged(params:any){
    console.log(params);
    if(!params.newValue){
      return;
    }
    if(params.value == "FLAT" || params.value == "PERCENTAGE"){
        this.finalCommissionData[params.rowIndex].commission = 0;
        this.gridApiSlab.setRowData(this.finalCommissionData);
        return;
      }

    if(params.column.colId == "maxCommission"){

      if(parseInt(this.finalCommissionData[params.rowIndex].maxCommission) == 0){
        this.finalCommissionData[params.rowIndex].minCommission = 0;
        this.gridApiSlab.setRowData(this.finalCommissionData);
        return;
      }

      if(parseInt(this.finalCommissionData[params.rowIndex].minCommission) > parseInt(this.finalCommissionData[params.rowIndex].maxCommission)){
        this.finalCommissionData[params.rowIndex].minCommission = 0;
        this.gridApiSlab.setRowData(this.finalCommissionData);
        return;
      }

      if(parseInt(this.finalCommissionData[params.rowIndex].maxCommission) > parseInt(this.finalCommissionData[params.rowIndex].toAmount)){
        this.finalCommissionData[params.rowIndex].maxCommission = 0;
        this.finalCommissionData[params.rowIndex].minCommission = 0;
        this.alertService.toastWarringMessageAlertWithMessage("Maximum Commission cannot be greater than TO AMOUNT");
        this.gridApiSlab.setRowData(this.finalCommissionData);
        return;
      }


    }else if(params.column.colId == "minCommission"){
      if(parseInt(this.finalCommissionData[params.rowIndex].minCommission)<0){
        this.finalCommissionData[params.rowIndex].minCommission = 0;
        this.gridApiSlab.setRowData(this.finalCommissionData);
        return;
      }
      console.log(this.finalCommissionData[params.rowIndex].minCommission);
      console.log(this.finalCommissionData[params.rowIndex].maxCommission);
      if(parseInt(this.finalCommissionData[params.rowIndex].minCommission) > parseInt(this.finalCommissionData[params.rowIndex].maxCommission)){
        this.alertService.toastWarringMessageAlertWithMessage("Minimum Commission cannot be greater than Maximum Commission");
        this.finalCommissionData[params.rowIndex].minCommission = 0;
        this.gridApiSlab.setRowData(this.finalCommissionData);
        return;
      }
    }else if(params.column.colId == "commission"){
      if(this.finalCommissionData[params.rowIndex].commissionType == "PERCENTAGE"){
        if(parseInt(this.finalCommissionData[params.rowIndex].commission) >= 100){
          this.alertService.toastWarringMessageAlertWithMessage("Maximum Commission cannot be greater than 100 Percentage");
          this.finalCommissionData[params.rowIndex].commission = 0;
          this.gridApiSlab.setRowData(this.finalCommissionData);
          return;
        }
      }else if(this.finalCommissionData[params.rowIndex].commissionType == "FLAT"){
        if(parseInt(this.finalCommissionData[params.rowIndex].commission) > parseInt(this.finalCommissionData[params.rowIndex].toAmount)){
          this.alertService.toastWarringMessageAlertWithMessage("Maximum Commission cannot be greater than TO AMOUNT");
          this.finalCommissionData[params.rowIndex].commission = 0;
          this.gridApiSlab.setRowData(this.finalCommissionData);
          return;
        }
      } 
    }
  }


  async selectSpecificAmount() {
    let inputSpecificAmount: HTMLInputElement;
    await Swal.fire({
      title: "Please enter the Specific Amount",
      html: '<input type="text" class="swal2-input" id="specificAmount" placeholder="Enter Specific Amount" maxlength="10" onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">',
      confirmButtonText: '<span id="confirm-button-text">OK</span>',
      showCancelButton: true,
      reverseButtons: true,
      confirmButtonColor: '#f56d1d',
      cancelButtonColor: '#d33',
      customClass: {
        confirmButton: 'swal2-confirm-custom',
        cancelButton: 'swal2-cancel-custom'
      },
      didOpen:()=>{
        const popup = Swal.getPopup()!
        inputSpecificAmount = popup.querySelector('#specificAmount') as HTMLInputElement
        inputSpecificAmount.onkeyup = (event) => event.key === 'Enter' && Swal.clickConfirm()
      },
      preConfirm:()=>{
        if(inputSpecificAmount.value != ""){
          console.log(inputSpecificAmount.value);
          if(parseInt(inputSpecificAmount.value) >= parseInt(this.editServiceProviderForm.value.maxBalance)){
            this.alertService.toastWarringMessageAlertWithMessage("Specific amount cannot be greater than max balance");
            return;
          }
          const newRow = { fromAmount: Number(inputSpecificAmount.value), isAmountDisabled: true, toAmount: Number(inputSpecificAmount.value), commission: 0,minCommission:0,productId: this.selectedProduct.id, maxCommission:0,  commissionType: "PERCENTAGE", serviceCharge: 0, effectiveUpdatedDate: moment().format("MM-DD-YYYY HH:mm"),type: "SPECIFIC AMOUNT"};

          // const newRow = { fromAmount: Number(inputSpecificAmount.value), toAmount: Number(inputSpecificAmount.value), serviceChargeType: "PERCENTAGE", serviceCharge: 0, effectiveUpdatedDate: moment().format("MM-DD-YYYY HH:mm"),isAmountDisabled: true  ,type:"SPECIFIC AMOUNT"};
            for(let i:number = 0;i<this.finalCommissionData.length;i++){
              if(this.finalCommissionData[i].fromAmount == this.finalCommissionData[i].toAmount){
                if(this.finalCommissionData[i].fromAmount == inputSpecificAmount.value){
                  this.alertService.toastWarringMessageAlertWithMessage("Please enter different specific amount");
                  return;
                }
              }
            }
            this.finalCommissionData = [...this.finalCommissionData, newRow];
            this.gridApiSlab.setRowData(this.finalCommissionData);
        }else{
          this.alertService.toastWarringMessageAlertWithMessage("Please enter specific amount");
          return;
        }
      },
    });
  }

  async deleteProduct(cardData : number, card : any){
    this.productNumber = cardData;
    console.log(cardData);
    console.log(this.productIds[cardData]);
    console.log(this.productTableList[cardData]);
    await Swal.fire({
      title: "Are you sure ?",
      text: "This action will impact the active product slabs as they won't be able to use the "+this.productTableList[cardData].productName,
      confirmButtonText: '<span id="confirm-button-text">Delete</span>',
      showCancelButton: true,
      reverseButtons: false,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#7987a1',
      customClass: {
        confirmButton: 'swal2-confirm-custom',
        cancelButton: 'swal2-cancel-custom'
      },
    }).then((result) => {
      if (result.isConfirmed) {
         
        this.providerService.deleteProductMapping(this.id,this.productIds[cardData]).subscribe((response:any)=>{
          console.log(response);
          if(response.response.status == 200){
            this.productTableList.splice(cardData, 1);
            this.productIds.splice(cardData, 1);
            // this.providerService.getServiceProviderById(this.id).subscribe((response:any)=>{
            //   console.log(response);
            //   this.setGetApiDataById(response);
           // });
            this.alertService.toastSuccessMessageAlertWithMessage("Product Deleted Successfully");
            console.log(this.productIds);
            console.log(this.productTableList);
          }
        });
      }else{
        console.log("Cancel");
        return;
      }
    });
    
    return;
    
  }

  OnlyCharacterAllowed(event: { which: any; keyCode: any; }): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    console.log(charCode);
    if(charCode == 32){
      return true;
    }else if ((charCode == 96 || charCode < 65 ||charCode > 122) && (charCode < 48 ||charCode > 57)) {
      return false;
    }
    return true;
  }

  onPaste(e: any) { 
    e.preventDefault()
  }

  statusOnChange(selectedStatus :any){
    console.log(selectedStatus);
    if(selectedStatus == "INACTIVE"){
      this.statusChangeModal.open();
    }
  }

  addRow(){
    for(let i:number = 0;i<this.finalCommissionData.length;i++){
      if(this.finalCommissionData[i].type == "SLAB" || this.finalCommissionData[i].type == "Slab"){
        const newRow = { fromAmount: 1, toAmount: 0, commissionType: "PERCENTAGE", commission: 0,minCommission:0,maxCommission:0,productId: this.selectedProduct.id, effectiveUpdatedDate: moment().format("MM-DD-YYYY HH:mm"), isAmountDisabled: false ,type:"SLAB"};
        this.finalCommissionData = [newRow, ...this.finalCommissionData];
        this.gridApiSlab.setRowData(this.finalCommissionData);
        return;
      }
    }
    const newRow = { fromAmount: 1, toAmount: this.editServiceProviderForm.value.maxBalance, commissionType: "PERCENTAGE", commission: 0,minCommission:0,maxCommission:0,productId: this.selectedProduct.id, effectiveUpdatedDate: moment().format("MM-DD-YYYY HH:mm"), isAmountDisabled: false ,type:"SLAB"};
    this.finalCommissionData = [newRow, ...this.finalCommissionData];
    this.gridApiSlab.setRowData(this.finalCommissionData);
  }


  clearButton(){
    this.slabData = [];
    this.finalCommissionData = [];
    this.gridApiSlab.setRowData(this.finalCommissionData);
  }

  setProductProfileByApi(profile: any) : Observable<any> {
    console.log("Choose File "+profile);
    let url = "product/"+profile;
    return this.productService.getProfileImage(url)
  }

  addSlabCheck(){
    if(!this.editCommissionForm.valid){
      this.alertService.errorAlertWithMessage("Please select product");
      return;
    }
    this.showDataTable = false;
    if(this.savedSlabData.length == 0){
      this.showDataTable = true;
    }else{
      for(let i:number = 0;i<this.savedSlabData.length; i++){
        if(this.savedSlabData[i].status == "PENDING"){
          this.alertService.errorAlertWithMessage("You cannot add new slab because previous slabs are pending for this product");
          return;
        }
      }
    }
    this.showDataTable = true;
    this.finalCommissionData = [];
  }
  statusChangeApi(){
    if(this.selectedStatus == undefined){
      Swal.fire('Please select Status','','error');
      return;
    }
    if(this.dbStatus == this.selectedStatus){
      Swal.fire('Status is already '+this.selectedStatus,'','error');
    }else{
      
      
      let requestData={
          "id":this.id
      }
      this.providerService.providerStatusChange(requestData,this.selectedStatus).subscribe((response:any)=>{
        console.log(response);
        if(response.response.status == 200){
          Swal.fire('Status Updated Successfully','','success');
        }else{
          Swal.fire(response.response.message,'','error');
        }
      })
    }
  }
  statusChangeCheck(status : any){
    this.selectedStatus = status;
    if(this.selectedStatus == "INACTIVE"){
      Swal.fire({
        title: "Are you sure?",
        text : "This action will impact the active users as they won't be able to use the product anymore",
        showCancelButton: true,
        confirmButtonText: '<span id="confirm-button-text">Confirm</span>',
        confirmButtonColor:'#f56d1d',
        cancelButtonColor : '#d33',
        customClass: {
          confirmButton: 'swal2-confirm-custom',
          cancelButton: 'swal2-cancel-custom'
        },
      }).then((result) => {
        if (result.isConfirmed) {
          this.editProductForm.controls.status.setValue("INACTIVE");
        } else{
          this.editProductForm.controls.status.setValue(null);
        }
      });
    }else{
      return;
    }

  }
   

  cloneData(){
    if(!this.editCommissionForm.valid){
      this.alertService.errorAlertWithMessage("Please select product");
      return;
    }
    this.finalCommissionData = [];
    this.showDataTable = false;
    if(this.savedSlabData.length != 0){
      for(let i : number = 0; i<this.savedSlabData.length; i++){
        if(this.savedSlabData[i].status== "PENDING"){
          this.alertService.errorAlertWithMessage("You cannot clone slab because the previous slabs are still in pending");
          this.showDataTable = false;
          return;
        }
      }
          console.log(this.savedSlabData);
          this.showDataTable = true;
          this.finalCommissionData = JSON.parse(JSON.stringify(this.savedSlabData));
          this.finalCommissionData = this.finalCommissionData.filter((_ : any)=>{
            return _.status=="ACTIVE"
          }).map((_: any) => {
            _.effectiveUpdatedDate = moment().format("MM-DD-YYYY HH:mm");
            _.isAmountDisabled = true;
            if(_.fromAmount == _.toAmount){
              _.type = "SPECIFIC AMOUNT"; 
            }else{
              _.type = "SLAB"; 
            }
            delete _.status;
            delete _.approvedBy;
            delete _.approvedOn;
            delete _.createdBy;
            delete _.createdOn;
            delete _.effectiveUpdateDate;
            // delete _.type;
            return _;
          });
          console.log(this.finalCommissionData);
    }else{
      this.alertService.errorAlertWithMessage("No slabs to be clone");
    }
  }

  reviewSlab(event:any){
    event.target.blur()
    if(!this.editCommissionForm.valid){
      this.alertService.errorAlertWithMessage("Please select product");
      return;
    }
    this.oldSlab = [];
    this.newSlab = [];
     this.showOldSlab = false;
    this.showNewSlab = false;
   
    for(let i:number = 0;i<this.savedSlabData.length;i++){
      if(this.savedSlabData[i].status == "PENDING"){
        this.newSlab.push(this.savedSlabData[i]);
      }else{
        this.oldSlab.push(this.savedSlabData[i]);
      }
    }
    if(this.newSlab.length == 0){
      this.alertService.errorAlertWithMessage("No slabs for review");
      return;
    }else{
      if(this.oldSlab.length == 0){
        this.showOldSlab = false;
      }else{
        this.showOldSlab = true;
      }
      this.showNewSlab = true;
      this.editServiceProviderModal.open();
    }
    
  }
  
  

  slabStatusChange(status : string){
    this.pid = [];
    console.log(this.id);
    console.log(this.selectedProduct.id);
    console.log(status);
    this.pid.push(this.selectedProduct.id);
    console.log(this.slabRemarks);
    if(this.slabRemarks==null||this.slabRemarks==undefined||this.slabRemarks==""){
      Swal.fire('Please Enter the Remarks', '', 'error');
      return;
    }
    let requestForm = {
      "id" : this.id,
      "productIds" : this.pid,
      "remark":this.slabRemarks,
    }
    this.providerService.reviewServiceProviderSlab(requestForm,status).subscribe((response:any)=>{
      console.log(response);
      this.editServiceProviderModal.close();
      if(response.response.status == 200){
        Swal.fire(response.response.message, '', 'success');
        this.providerService.getServiceProviderSlabById(this.id,this.selectedProduct.id).subscribe((response:any)=>{
          console.log(response.response.data);
          if(response.response.data.length != 0){
            this.showSavedTable = true;
            this.savedSlabData = response.response.data.slabs;
          }else{
            this.showSavedTable = false;
          }
          })

      }else{
        Swal.fire("Error while changing the status of slabs", '', 'error');
        return;
      }
    })
  }

  

  confirmModal(){
    this.statusChangeModal.close();
    this.editServiceProviderForm.controls.status.setValue("INACTIVE");
  }

  closeModalBlocked($event: any) {
    if (!$event.showModal) {
      this.statusChangeModal.close();
      this.editServiceProviderForm.controls.status.setValue(null);
    }
  }

}
